import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorLocationResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorLocation: metadata.getAuthorLocation() } as StreamData)

export default authorLocationResolver
